import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import { Wrapper } from '../../Container/Container.style'
import Accordion from '../../../shared/Accordion'
import { FaqContainer } from './FAQ.style'
import { SecondaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'

export default function FAQ(props) {
  const { title, accordionItems, enableViewAllCta, ctaLabel, url } = props
  return (
    <Wrapper>
      <FaqContainer className="wow fadeIn" data-wow-delay="0.4s">
        <h3>{title}</h3>
        {accordionItems.map(item => {
          return <Accordion item={item} key={item.id} />
        })}
        {enableViewAllCta && (
          <SecondaryButton className="centerAlign">
            <Link to={url} className="viewAllCTA">
              {ctaLabel}
              <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
            </Link>
          </SecondaryButton>
        )}
      </FaqContainer>
    </Wrapper>
  )
}

export const FAQFragment = graphql`
  fragment FAQFragment on ContentfulAccordionContainer {
    id
    title
    enableViewAllCta
    ctaLabel
    url
    accordionItems {
      title
      description {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

FAQ.propTypes = {
  title: PropTypes.string.isRequired,
  enableViewAllCta: PropTypes.bool,
  ctaLabel: PropTypes.string,
  url: PropTypes.string,
  accordionItems: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
}

FAQ.defaultProps = {
  enableViewAllCta: false,
  ctaLabel: '',
  url: '',
}
